// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_ENDPOINT,
    credentials: 'include',
    prepareHeaders: (headers) => {
      if (process.env.REACT_APP_DISABLE_LOGIN == 'true') {
        headers.set('Mock-User', localStorage.getItem('local_user_id')!);
      }
    },
  }),
  endpoints: () => ({}),
});
